// Helpers
function abToB64 (buf) {
  return btoa(String.fromCharCode(...new Uint8Array(buf)))
}
function abToB64url (buf) {
  // base64url (safer in urls)
  return abToB64(buf).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
}

// Main Course
export async function encryptPayload (payloadObj, opts = {}) {
  const pubKeyPem = import.meta.env.VITE_APP_PUBLIC_KEY.replace(/\\n/g, '\n')

  // Konversi PEM ke ArrayBuffer
  const pemHeader = '-----BEGIN PUBLIC KEY-----'
  const pemFooter = '-----END PUBLIC KEY-----'
  const pemContents = pubKeyPem.substring(
    pemHeader.length,
    pubKeyPem.length - pemFooter.length
  ).replace(/\s+/g, '')

  const binaryDer = Uint8Array.from(atob(pemContents), c => c.charCodeAt(0))

  // Import ke CryptoKey
  const pubKey = await crypto.subtle.importKey(
    'spki',
    binaryDer.buffer,
    {
      name: 'RSA-OAEP',
      hash: 'SHA-256'
    },
    false, // not extractable
    ['encrypt']
  )

  // 1. create AES-GCM key (ephemeral)
  const aesKey = await crypto.subtle.generateKey(
    { name: 'AES-GCM', length: 256 },
    true, // extractable because we'll export raw to encrypt it with RSA
    ['encrypt', 'decrypt']
  )

  // 2. IV 12 bytes (96-bit) recommended for GCM
  const iv = crypto.getRandomValues(new Uint8Array(12))

  // 3. Add timestamp & nonce inside plaintext to prevent replay
  const ts = Date.now()
  const nonce = Array.from(crypto.getRandomValues(new Uint8Array(12))).map(n => n.toString(16).padStart(2, '0')).join('')
  const plaintextStr = JSON.stringify({ ts, nonce, data: payloadObj })

  // 4. encrypt payload with AES-GCM
  const encBuf = await crypto.subtle.encrypt(
    { name: 'AES-GCM', iv },
    aesKey,
    new TextEncoder().encode(plaintextStr)
  )

  // 5. export raw AES key and encrypt it with RSA-OAEP
  const rawAes = await crypto.subtle.exportKey('raw', aesKey) // ArrayBuffer
  const encryptedAesKeyBuf = await crypto.subtle.encrypt(
    { name: 'RSA-OAEP' },
    pubKey,
    rawAes
  )

  // 6. best-effort zeroing of rawAes and AES key material from memory:
  try {
    // overwrite rawAes buffer view if possible
    const view = new Uint8Array(rawAes)
    view.fill(0)
  } catch (e) { /* best-effort only */ }

  // 7. package result (use base64url)
  return JSON.stringify({
    key_id: opts.keyId || null, // optional, helpful for key rotation
    encrypted_key: abToB64url(encryptedAesKeyBuf),
    iv: abToB64url(iv.buffer),
    ciphertext: abToB64url(encBuf),
    ts,
    nonce
  })
}
